<template>
  <onboarding-account-type />
</template>

<script>
import OnboardingAccountType from '@/components/Onboarding/AccountType/index'
export default {
    components: {
        OnboardingAccountType
    }
}
</script>

<style>

</style>